<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <form @submit.prevent="saveSet()">
          <div class="modal-container child">
            <div class="modal-header"><h3>Save Set</h3></div>
            <div class="modal-body">
              <div class="form-group row">
                <div
                  :class="{
                    'has-error':
                      hasErrors && setName === null,
                  }"
                  class="col-xs-6">
                  <label for="set-name">Set Name</label>
                  <input
                    id="set-name"
                    v-model="setName"
                    name="set-name"
                    type="text"
                    required
                    class="form-control">
                </div>
              </div>
              <div
                v-if="hasErrors && !isValid"
                class="alert alert-danger"
                role="alert">
                <button type="button" class="close">
                  <span aria-hidden="true">×</span>
                </button>
                <p>Please fill in the mandatory fields.</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Save
              </button>
              <button
                type="button"
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../services/eventBus.js';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['name',],
	data() {
		return {
			setName: '',
			hasErrors: false,
		};
	},
	computed: {
		isValid() {
			return this.setName !== '' && this.setName !== null;
		},
	},
	created() {
		this.setName = this.name;
	},
	methods: {
		saveSet() {
			let _self = this;
			if (_self.setName === '') {
				this.hasErrors = true;
			} else {
				EventBus.$emit('saveSet', _self.setName);
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalSaveSet.vue